<template>

  <div class="edit">
    
    <!-- <h1>This is the Calendar page</h1> -->

    <div class="myheaderbar">
      <h1>KALENDÁR</h1>
    </div>

    <div class="columns">
      
      <div class="column is-half" style="margin: 0em;">
        <Calendar msg="Calendar"/>
      </div>
      
      <div class="column" style="margin: 0em;">

        <!-- {{localSelectedEvent}} -->

        <div>
          <a class="button is-light"  @click="addEvent">
            <div>  
              <i class="fas fa-plus-square" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
            </div>
            NEW Event
          </a>

          <a class="button is-light"  @click="$router.push('/main/googlecontact')">
            <div>  
              <i class="fas fa-plus-square" style="color: green; margin-right: 1em; font-size:1.8em;" aria-hidden="true"></i>
            </div>
            Google Sync
          </a>
        </div>

        <EditEvent :localSelectedEvent="localSelectedEvent" v-model="localSelectedEvent"/>


        <!-- <GoogleImport/>
        <br><br>
        <GoogleImport2/> -->
      </div>
  </div>


  

  </div>
</template>


<script>

  import Calendar from '@/components/main/calendar/Calendar.vue'
  // import GoogleImport from '@/components/main/calendar/GoogleImport.vue' 
  // import GoogleImport2 from '@/components/main/calendar/GoogleImport2.vue' 
  import EditEvent from '@/components/main/calendar/EditEvent.vue'
  import { mapGetters, mapActions } from 'vuex';
  import {EventStruct} from '@/utils/structs';
  
  
  export default {
    name: "calendarview",
    components: {
      Calendar,
      EditEvent,
      // GoogleImport,
      // GoogleImport2
    },
    data() {
      return {
        localSelectedEvent: null
      }
    },
    created () {
      this.localSelectedEvent = this.createLocalSelectedEvent(this.selectedEvent)
    },
    computed: {
      ...mapGetters(['selectedEvent'])
    },
    methods: {
      ...mapActions(['addNewEvent', 'putSelectedEvent']),
      addEvent () {
        // let tmp = JSON.parse(JSON.stringify(EventStruct))
        // console.log(JSON.stringify(tmp))
        // return 
        let tmpES = EventStruct
        tmpES.start.date = new Date()
        tmpES.end.date = new Date()
        tmpES.start.dateTime = new Date()
        tmpES.end.dateTime = new Date()
        // this.localSelectedEvent = this.createLocalSelectedEvent(EventStruct)
        this.localSelectedEvent = this.createLocalSelectedEvent(tmpES)

        console.log(JSON.stringify(this.localSelectedEvent))

        this.addNewEvent(this.localSelectedEvent)
        this.putSelectedEvent(this.localSelectedEvent)
      },
      createLocalSelectedEvent (event) {
        let tmpevent = JSON.parse(JSON.stringify(event))  //..making a copy (by parsing JSON )
        // tmpevent.start.date = tmpevent.start.date.length>0 ? new Date(tmpevent.start.date) : Date.now()
        tmpevent.start.date = new Date(tmpevent.start.date)
        tmpevent.end.date = new Date(tmpevent.end.date)
        tmpevent.start.dateTime = new Date(tmpevent.start.dateTime)
        tmpevent.end.dateTime = new Date(tmpevent.end.dateTime)

        return tmpevent
      },
      
      // addChannel () {
      //   this.localSelectedContact.channels.unshift(
      //     {type: null, info: '', atags: [], tags: [], pref: false} 
      //     )
      
    },
    watch: {
      selectedEvent (newValue) {
        // console.log(`Updating from ${oldValue} to ${newValue}`);
        // console.log(`Updating  ${JSON.stringify(newValue)}`);
        
        this.localSelectedEvent = this.createLocalSelectedEvent(newValue) // ..JSON.parse(JSON.stringify(newValue))  //..making a copy (by parsing JSON )
        console.log("watch -> selectedEvent @ CalendarView.vue triggered")
      }
    }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
</style>